export const getImage = async x => (!x || typeof x === 'string' ? x : readFileAsDataUrl(x))

export const readFileAsDataUrl = async x =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = e => resolve(e.target?.result)
    reader.onerror = e => reject(e)
    reader.readAsDataURL(x)
  })

export const mbToBytes = x => x * 1024 * 1024

export const mimeMatches = (type, patterns) =>
  patterns.some(p => (p.endsWith('/*') ? type.startsWith(p.slice(0, -1)) : type === p))

export const fileFromInput = x => {
  if (x instanceof File) return x
  if (x instanceof FileList) return x.item(0) || undefined
  if (Array.isArray(x)) return x[0]
  if (x == null || x === '') return undefined

  return x // assume File
}

export const filesFromInput = x => {
  if (x instanceof FileList) return Array.from(x)
  if (Array.isArray(x)) return x
  if (x instanceof File) return [x]
  if (x == null || x === '') return []

  return x // assume File[]
}

export const getImageMeta = async file => {
  const url = URL.createObjectURL(file)

  try {
    const img = new Image()
    img.decoding = 'async'
    img.src = url

    await new Promise((res, rej) => {
      img.onload = () => res()
      img.onerror = () => rej(new Error('Bad image'))
    })

    return { height: img.naturalHeight, width: img.naturalWidth }
  } finally {
    URL.revokeObjectURL(url)
  }
}

export const getVideoMeta = async file => {
  const url = URL.createObjectURL(file)

  try {
    const video = document.createElement('video')
    video.preload = 'metadata'
    video.muted = true
    video.src = url

    await new Promise((res, rej) => {
      video.onloadedmetadata = () => res()
      video.onerror = () => rej(new Error('Bad video'))
    })

    return { duration: video.duration || 0, height: video.videoHeight, width: video.videoWidth }
  } finally {
    URL.revokeObjectURL(url)
  }
}

export const getVideoPoster = async (file, atSeconds = 1) => {
  const url = URL.createObjectURL(file)

  let cleanup = () => {}

  try {
    const video = document.createElement('video')
    video.preload = 'metadata'
    video.muted = true
    video.src = url

    const loaded = new Promise((res, rej) => {
      video.onloadedmetadata = () => res()
      video.onerror = () => rej(new Error('Bad video'))
    })
    await loaded

    const target = Math.min(Math.max(0, atSeconds), Math.max(0, (video.duration || 0) - 0.1))
    const seeked = new Promise((res, rej) => {
      const timer = setTimeout(() => rej(new Error('Seek timeout')), 1500)
      cleanup = () => clearTimeout(timer)
      video.onseeked = () => {
        clearTimeout(timer)
        res()
      }
      video.onerror = () => {
        clearTimeout(timer)
        rej(new Error('Seek error'))
      }
    })

    try {
      video.currentTime = target
      await seeked
    } catch {
      // if seek fails, proceed with the current frame
    }

    const w = video.videoWidth || 0
    const h = video.videoHeight || 0
    if (!w || !h) throw new Error('No video dimensions')

    const canvas = document.createElement('canvas')
    canvas.width = w
    canvas.height = h

    const ctx = canvas.getContext('2d', { willReadFrequently: false })
    ctx.drawImage(video, 0, 0, w, h)

    return canvas.toDataURL('image/jpeg', 0.8)
  } finally {
    cleanup()
    URL.revokeObjectURL(url)
  }
}
